const config = {
	appDomain: 'https://progress-ai.kellypartners.com',
	apiDomain: 'https://api.kellypartners.com/',
	blobStorageRootUrl: 'https://appassets.kellypartners.com/',
	iPracticeRootUrl: '',
	environment: 'mcprod',
	title: 'McProduction',
	currentCulture: 'en-US',
	stripePublishableKey:
		'pk_live_51NLK97ItboXz9npVFxgIj7ng9gl0vEwvyud5yWUd4wpRt0GygCZqHJShP9YOmKUfgt6DDYD7eicF6WYtq75Oai4m00OZI2Le9l',
	appSupportEmail: 'progressai@kellypartners.com',
	appName: 'McProgress',
	appVersion: '1.17.0',
	autoLogoutTimeoutInMs: 1800000,
	streamApiKey: '7jtgrhdd6ukg'
};

export type Config = typeof config;

export default config;
